// extracted by mini-css-extract-plugin
export default {"clickableIcon":"PictureStartupForm_clickableIcon__RR7fG","iconsContainer":"PictureStartupForm_iconsContainer__3AGvX","imageContainer":"PictureStartupForm_imageContainer__EDdUc"};